import { INode } from '../../../shared/models/node.model'
import { getEventListItemAnalytics } from '../../events/components/event-list-item/event-list-item.component'
import { Node } from 'src/io/models/node'
import { FloEvent } from '@flocasts/flosports30-types/dist/entity'
import { FloGeoEvent } from 'src/app/events/interfaces/flo-geo-event.interface'
import { AnalyticsProperties } from '../../../shared/analytics/models/analytics-properties.interface'

export interface NodeItemAnalytics extends AnalyticsProperties {
  name: string
  item_order: number
  array_length: number
  node_id: number
  node_type?: string
  is_premium?: boolean
  primary_association_id?: number
  primary_association_title?: string
}

export interface NodeAnalytics extends INode {
  analyticProps: NodeItemAnalytics
}

/**
 * @deprecated This uses a deprecated type. Use the modernized version.
 *
 * @see getContentAnalytics
 */
export function getNodeAnalytics(node: INode, i: number, arrLength: number): NodeItemAnalytics {
  return {
    name: node.title,
    item_order: i,
    array_length: arrLength,
    node_id: node.id,
    node_type: node.type,
    is_premium: node.premium,
    primary_association_id:
      node.node && node.node.primary_event_or_series_association && node.node.primary_event_or_series_association.id,
    primary_association_title:
      node.node && node.node.primary_event_or_series_association && node.node.primary_event_or_series_association.title
  }
}

/**
 * @deprecated A type-safe version of this has been implemented.
 *
 * @see getListItemAnalytics
 */
export function getAnalytics(node: INode | FloEvent | FloGeoEvent | Node, i: number, arrLength: number) {
  switch (node.type) {
    case 'event':
      return getEventListItemAnalytics(node as unknown as FloGeoEvent, i)
    default:
      return getNodeAnalytics(node as INode, i, arrLength)
  }
}
